export const VESSEL_PARTICULARS_STORE_ID = 'VesselParticularsStore';
